import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=5e787bcf&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports